import { hasKey, pruneLegacyKeys, readJson, STORAGE_KEYS, writeJson } from './storage'
import { initialDealInvoices, initialDealShipments, initialDeals } from './seed/deals'
import type { Deal, Shipment } from '../types/deal'
import type { Invoice } from '../types/invoice'

interface DealStateFlags {
  archivedDealIds: string[]
  canceledDeals: Record<string, { mode: 'end_of_period' | 'immediate'; canceledAt: string }>
}

type InvoicesByDealId = Record<string, Invoice[]>
type ShipmentsByDealId = Record<string, Shipment[]>

export function ensureSeeded(): void {
  // Wipe legacy v7 + v8 keys on first hydrate after the v9 bump. Mock is demo
  // state, not durable — migration would be wasted code.
  pruneLegacyKeys()

  if (!hasKey(STORAGE_KEYS.deals)) {
    writeJson(STORAGE_KEYS.deals, initialDeals)
  }
  if (!hasKey(STORAGE_KEYS.state)) {
    const flags: DealStateFlags = { archivedDealIds: [], canceledDeals: {} }
    writeJson(STORAGE_KEYS.state, flags)
  }
  if (!hasKey(STORAGE_KEYS.dealInvoices)) {
    writeJson(STORAGE_KEYS.dealInvoices, initialDealInvoices)
  }
  if (!hasKey(STORAGE_KEYS.dealShipments)) {
    writeJson(STORAGE_KEYS.dealShipments, initialDealShipments)
  }
}

export function readDeals(): Deal[] {
  ensureSeeded()
  return readJson<Deal[]>(STORAGE_KEYS.deals, [])
}

export function writeDeals(deals: Deal[]): void {
  writeJson(STORAGE_KEYS.deals, deals)
}

export function readState(): DealStateFlags {
  ensureSeeded()
  return readJson<DealStateFlags>(STORAGE_KEYS.state, { archivedDealIds: [], canceledDeals: {} })
}

export function writeState(state: DealStateFlags): void {
  writeJson(STORAGE_KEYS.state, state)
}

export function readDealInvoices(): InvoicesByDealId {
  ensureSeeded()
  return readJson<InvoicesByDealId>(STORAGE_KEYS.dealInvoices, {})
}

export function writeDealInvoices(map: InvoicesByDealId): void {
  writeJson(STORAGE_KEYS.dealInvoices, map)
}

export function readDealShipments(): ShipmentsByDealId {
  ensureSeeded()
  return readJson<ShipmentsByDealId>(STORAGE_KEYS.dealShipments, {})
}

export function writeDealShipments(map: ShipmentsByDealId): void {
  writeJson(STORAGE_KEYS.dealShipments, map)
}
